import React from 'react';

import ReactDOM from 'react-dom';

import {
	Button,
	Tabs
} from "@jd/find-react";




import KeeVue from '../../base/KeeVue.js'

import $ from 'jquery';



export default class FsPic extends KeeVue {
	constructor(props) {
		super(props);
window.fileUrl=window.fileUrl.replace("http:",document.location.protocol);
		this.state = {
			isShow: false,
			randId: this.getRandString(),
			isShowMenu: false,
			toHide: false,
			rootFileUri: window.fileUrl + ("/api/fs/getById?"),
			defaultImgUrl: window.rootUri + "/kee_static/images/noimage.gif",
			isScrolling: false,
			selectItem: null,
			menuStyle: {
				left: 5,
				top: 0,
				width: 0,
				height: 0,
			},
			imgComponent: {
				cp: {
					listSizeClass: ""
				},
				rowid: this.props.component.rowid,
				value: "",
			},
			isFullUrl: false,
		}

	}


		getImgUrl=()=>{
			 
			if(this.props.component.value)
			{
				if(this.props.component.value  && this.props.component.value.startsWith("http")) {
				this.isFullUrl = true;
				return this.props.component.value.replace("http:",document.location.protocol);
				}
				else
				{
				return this.state.rootFileUri+'ids='+this.props.component.value;
					
				}
			
			}
			
			if(this.props.component.cp.url)
			{
				if(  this.props.component.cp.url.startsWith("http")) {
				this.isFullUrl = true;
				return this.props.component.cp.url.replace("http:",document.location.protocol);
				}
				else
				{
				return this.state.rootFileUri+'ids='+this.props.component.cp.url;
					
				}
			
			}
			
			return this.state.defaultImgUrl;
		}
			
	componentWillReceiveProps(nextProps){
		
		this.state.imgUrl = this.getImgUrl();
		
		if(this.imgUrl!=this.state.imgUrl)
		{
			this.imgUrl=this.state.imgUrl;
			this.refresh();
		}
		 
		 
		
		}
	componentWillMount() {
		this.registComponent();
		
		
		 
		if (this.props.component.value&&this.props.component.value.indexOf(' ') !== -1) {
			this.props.component.value = '';
		}
		if (!this.props.component.style.width&&!this.props.component.style.height) {
			this.setVueAttr(this.props.component.style, "width", "400px");
			this.setVueAttr(this.props.component.style, "height", "300px");
			this.props.component.style.display = "inline-block";
		}
		this.setVueAttr(this.props.component.style, "overflow", "visible");
		console.log("执行了初始化方法。。。。。。。。。。。。。。。。。。。。。。。。" + this.props.component.alias);
		console.log(JSON.stringify(this.props.component));
		
		this.state.imgUrl = this.getImgUrl();
		this.refresh();
	}

 
	sendClick = () => {
		var that = this;
		this.sendPageEvent("click",this.props.component, this.props.po, this.props.thisForm, this.props.parentForm);
		 
	}

	render() {
		return (
			<div style={{ width:'100%',height:'100%'}} onClick={this.sendClick } >
			    <img src={this.state.imgUrl} style={{height:' 100%', width:' 100%'}} draggable="false" >
			    </img>
			</div>
		);
	}
}
